import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7811939f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLBidWaypoint" }
const _hoisted_2 = { class: "FTLBidWaypoint__container" }
const _hoisted_3 = { class: "container__field" }
const _hoisted_4 = { class: "field__placeholder" }
const _hoisted_5 = { class: "field__value" }
const _hoisted_6 = { class: "container__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Наименование отправителя", -1))
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = { class: "container__field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Адрес отправителя", -1))
const _hoisted_11 = { class: "field__value" }
const _hoisted_12 = { class: "container__field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Контактное лицо", -1))
const _hoisted_14 = { class: "field__value" }
const _hoisted_15 = { class: "container__field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер отправителя", -1))
const _hoisted_17 = { class: "field__value" }
const _hoisted_18 = { class: "container__field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Наименование получателя", -1))
const _hoisted_20 = { class: "field__value" }
const _hoisted_21 = { class: "container__field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Адрес получателя", -1))
const _hoisted_23 = { class: "field__value" }
const _hoisted_24 = { class: "container__field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Контактное лицо", -1))
const _hoisted_26 = { class: "field__value" }
const _hoisted_27 = { class: "container__field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер получателя", -1))
const _hoisted_29 = { class: "field__value" }
const _hoisted_30 = {
  key: 1,
  class: "FTLBidWaypoint__actions"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ftl_additional_service = _resolveComponent("ftl-additional-service")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.waypoint.is_endpoint)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Конечный пункт")
              ], 64))
            : (_ctx.waypoint.number === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Отправной пункт")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode("Остановка")
                ], 64))
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.waypoint.city_name), 1)
      ]),
      (_ctx.waypoint.number === 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_ctx.waypoint.sender_template)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.waypoint.sender_template.title || '-'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                (_ctx.waypoint.sender_template)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.waypoint.sender_template.full_address || '-'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                (_ctx.waypoint.sender_template)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.waypoint.sender_template.full_name || '-'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                (_ctx.waypoint.sender_template)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.waypoint.sender_template.phone || '-') + ", " + _toDisplayString(_ctx.waypoint.sender_template.additional_phone || '-'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                (_ctx.waypoint.receiver_template)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.waypoint.receiver_template.title || '-'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                (_ctx.waypoint.receiver_template)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.waypoint.receiver_template.full_address || '-'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                (_ctx.waypoint.receiver_template)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.waypoint.receiver_template.full_name || '-'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                (_ctx.waypoint.receiver_template)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.waypoint.receiver_template.phone || '-') + ", " + _toDisplayString(_ctx.waypoint.receiver_template.additional_phone || '-'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ])
            ])
          ], 64))
    ]),
    (Boolean(_ctx.waypoint.additional_service) && _ctx.waypoint.additional_service.length)
      ? (_openBlock(), _createBlock(_component_ftl_additional_service, {
          key: 0,
          "additional-service": _ctx.waypoint.additional_service
        }, null, 8, ["additional-service"]))
      : _createCommentVNode("", true),
    (_ctx.waypoint.number !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createVNode(_component_the_button, {
            class: "primary small",
            loading: _ctx.state.is_print_invoice_loading,
            disabled: _ctx.state.is_print_invoice_loading,
            onClick: _ctx.onPrintInvoice
          }, {
            default: _withCtx(() => [
              _hoisted_31,
              _createTextVNode(" Распечатать накладную ")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}